import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// classHover: 'linkNotUnderLine' || 'linkUnderLine' , (linkUnderline not have i)
// fontSize: 'fH4' || 'fH5' || 'fH6'
// if have <i></i> => children: <i></i>... or ...<i></i>
// leftClassIcon, rightClassIcon: className of <i></i>

// <Link href='#' classHover='link-not-underline' fontSize='f-h6' rightClassIcon='fas fa-arrow-left'>
//   OCBC back Home
// </Link>

const useStyles = makeStyles((theme) => ({
  root: {},
  linkComponent: {
    color: theme.palette.$clearBlue,
    fontWeight: 'normal',
    transition: 'all 0.5s ease',
    textDecoration: 'none !important',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
  },

  linkNotUnderLine: {
    '& .rightIcon': {
      marginLeft: '3px',
      transition: 'all 0.8s ease',
      width: '12px',
      height: 'auto',
    },
    '& .leftIcon': {
      marginRight: '3px',
      transition: 'all 0.8s ease',
      width: '12px',
      height: 'auto',
    },
    '&:hover': {
      color: theme.palette.$linkHover,
      '& .rightIcon': {
        color: theme.palette.$linkHover,
        transform: 'translateX(-5px)',
      },
      '& .leftIcon': {
        color: theme.palette.$linkHover,
        transform: 'translateX(-5px)',
      },
    },
    '&.battleship-grey': {
      color: theme.palette.$battleshipGrey,
      '&:hover': {
        color: theme.palette.$linkHover,
      },
    },
    '&.cool-grey': {
      color: theme.palette.$coolGrey,
      '&:hover': {
        color: theme.palette.$linkHover,
      },
    },
  },

  linkUnderline: {
    background: `linear-gradient( 180deg, transparent 1px, ${theme.palette.$linkHover} 1px, ${theme.palette.$linkHover} 2px, transparent 2px)`,
    backgroundPosition: 'left bottom',
    backgroundSize: '0% 3px',
    transition: 'background-size 0.3s ease-in-out',
    backgroundRepeat: 'no-repeat',
    paddingBottom: '2px',
    borderBottom: '3px solid transparent',
    fontSize: theme.typography.$fzH4,
    '@media (max-width: 767px)': {
      fontSize: theme.typography.$fzH5,
    },
    '&:hover': {
      backgroundSize: '100% 3px',
      color: '#0056b3',
    },
  },
  fH4: {
    fontSize: theme.typography.$fzH4,
  },
  fH5: {
    fontSize: theme.typography.$fzH5,
    '@media screen and (max-width: 767px)': {
      fontSize: theme.typography.$fzH6,
    },
  },
  fH6: {
    fontSize: theme.typography.$fzH6,
  },
  clearBlue: {
    color: theme.palette.$clearBlue,
  },
}));

const Link = ({
  href,
  children,
  target = '_blank',
  classHover,
  fontSize,
  leftIcon,
  rightIcon,
  color,
}) => {
  const classes = useStyles();
  return (
    <a
      href={href}
      className={`${classes.linkComponent} 
      ${classHover === 'linkUnderline' ? classes.linkUnderline : classes.linkNotUnderLine}
      ${classes[fontSize]}
      ${color}
      `}
      // eslint-disable-next-line react/jsx-no-target-blank
      target={target}
    >
      {leftIcon && (
        <ArrowBackIosIcon className="leftIcon" />
      )}
      <span>{children}</span>
      {rightIcon && <ArrowForwardIosIcon className="rightIcon" />}
    </a>
  );
};

Link.defaultProps = {
  leftIcon: false,
  rightIcon: false,
  target: '_blank',
  color: '',
  href: '',
  fontSize: '',
};

Link.propTypes = {
  href: PropTypes.string,
  classHover: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  leftIcon: PropTypes.bool,
  rightIcon: PropTypes.bool,
  color: PropTypes.string,
  target: PropTypes.string,
};

export default Link;
